module.exports = __webpack_public_path__ + "static/media/maps.1c98696d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/payment/maps.png
// module id = 651
// module chunks = 0